import {VideoPokerCardCombinationName} from "./VideoPokerCardCombinationName";

export class VideoPokerCombinationMultiplier {
    /**
     * paytable values taken from this page:
     * http://www.videopokerballer.com/pay-tables/jacks-or-better/
     * our version - 8/6 Jacks or Better
     * RTP with perfect strategy: 98.39%
     */
    public static get(videoPokerCardCombinationName: VideoPokerCardCombinationName): number {
        switch (videoPokerCardCombinationName) {
            case VideoPokerCardCombinationName.NOTHING:
                return 0;
            case VideoPokerCardCombinationName.JACKS_OR_BETTER:
                return 1;
            case VideoPokerCardCombinationName.TWO_PAIRS:
                return 2;
            case VideoPokerCardCombinationName.THREE_OF_A_KIND:
                return 3;
            case VideoPokerCardCombinationName.STRAIGHT:
                return 4;
            case VideoPokerCardCombinationName.FLUSH:
                return 6;
            case VideoPokerCardCombinationName.FULL_HOUSE:
                return 8;
            case VideoPokerCardCombinationName.FOUR_OF_A_KIND:
                return 25;
            case VideoPokerCardCombinationName.STRAIGHT_FLUSH:
                return 50;
            case VideoPokerCardCombinationName.ROYAL_FLUSH:
                return 800;
            default:
                throw new Error("Combination does not exist");
        }
    }

    private constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/VideoPokerCombinationMultiplier.ts